// extracted by mini-css-extract-plugin
export default {"skeletonCard":"skeletonCard_skeletonCard__K0EGb","card":"skeletonCard_card__bbKm-","distance":"skeletonCard_distance__HO4-1","name":"skeletonCard_name__jyl1k"};